import type { CmsLink } from '@omnia/ui/src/lib'
import { Modal } from '@vista-digital/occ-ui'
import { observer } from 'mobx-react'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import { RichText } from '@/common/components/richText/RichText'
import { SignInForm } from '@/common/components/signInForm/SignInForm'
import { signInModalStore } from '@/common/components/signInModal/signInModal.store'
import { useInitialData } from '@/common/hooks/useInitialData'
import { navigationService } from '@/common/services/navigation.service'

export const SignInModal = observer(() => {
    const { signInForm, passwordResetForm, signInModal } = useInitialData().header
    const { isOpen, closeSignInModal } = signInModalStore

    const signUpLink: CmsLink = {
        url: navigationService.getPageUrl('MembershipSales'),
        name: signInModal.joinNowLabel,
        target: '_self',
    }

    const onAfterSuccessfulSubmit = () => {
        signInModalStore.runPostLoginCallback()
        signInModalStore.closeSignInModal()
    }

    return (
        <Modal show={isOpen} onClose={closeSignInModal} header="Sign In" className={'sign-in-modal'}>
            <SignInForm
                signInFormDisplayText={signInForm}
                passwordResetFormDisplayText={passwordResetForm}
                onAfterSuccessfulSubmit={onAfterSuccessfulSubmit}
            />
            <div className="modal-message">
                <h3>Non-Members</h3>
                <RichText text={signInModal.modalMessage} />
                <CtaButton link={signUpLink} onClick={closeSignInModal} />
            </div>
        </Modal>
    )
})
